import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=c8dcc1da&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&id=c8dcc1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dcc1da",
  null
  
)

export default component.exports